

import {Component, EventEmitter, Input, OnInit, Output, ViewContainerRef} from '@angular/core';
import {ApiAdminCannedResponsesService} from "../../../../../services/api/admin/admin-canned-responses-api/admin-canned-responses-api.service";
import {Dialog} from "../../../../../shared/dialog/dialog";
import {OptionsApiService} from "../../../../../services/api/options/options-api.service";

@Component({
  selector: 'app-admin-canned-responses-create-edit-dialog',
  templateUrl: './admin-canned-responses-create-edit-dialog.component.html'
})

export class AdminCannedResponsesComponentDialog implements Dialog {

  @Input() data;
  @Output() remove = new EventEmitter<any>();

  isLoading = true;
  isLoadingRequestTypes = true;
  loadedId = null;

  loadedData;
  requestTypes;

  constructor(
    private apiAdminCannedResponsesService: ApiAdminCannedResponsesService,
    private apiAdminOptionsService: OptionsApiService
  ) {
    this.getRequestTypes();
  }


  ngOnInit(): void {
    if(this.data !== null){
      this.loadedId = this.data;
      this.getData();
    } else {

      // Load Default Data
      this.loadedData = {
        Name: '',
        Response: '',
        TypeId: null
      }

      this.isLoading = false;

    }
  }

  getRequestTypes(){
    this.isLoadingRequestTypes = true;
    this.apiAdminOptionsService.AllRequestTypes().then(response => {
      this.requestTypes = response;
      this.isLoadingRequestTypes = false;
    })
  }

  getData(){
    this.isLoading = true;
    this.apiAdminCannedResponsesService.get(this.loadedId).then(response => {
      this.loadedData = response;
      this.isLoading = false;
    })
  }

  close(){
    this.remove.emit(null);
  }

  save(){
    if(this.loadedId){
      this.apiAdminCannedResponsesService.update(this.loadedId, this.loadedData).then(response => {
        this.remove.emit("Saved");
      })
    } else {
      this.apiAdminCannedResponsesService.create(this.loadedData).then(response => {
        this.remove.emit("Saved");
      })
    }

  }
}
